module.exports = __webpack_public_path__ + "static/pin-orange-49758ce8da940cc689b5560ed1ac666e.png";